















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'
import Apis from '@/Apis/_'
import { TIPO_USUARIO_LABELS } from '@/components/Configuracoes/tipoUsuarioLabels'

interface LogAlteracaoTipo {
  id: number
  usuarioId: string
  tipoAnterior: string
  tipoNovo: string
  dadoAntesDaAlteracao: string
  createdOn: string
  createdBy: string
}

@Component
export default class ModalLogsAlteracaoTipoUsuario extends Vue {
  @Prop({ required: true }) visible!: boolean
  @Prop({ required: true }) usuarioId!: string

  logs: LogAlteracaoTipo[] = []
  loading: boolean = false

  headers = [
    { text: 'Data/Hora', value: 'createdOn', sortable: false },
    { text: 'Tipo anterior', value: 'tipoAnterior', sortable: false },
    { text: 'Tipo novo', value: 'tipoNovo', sortable: false },
    { text: 'Alterado por', value: 'createdBy', sortable: false },
  ]

  @Watch('visible')
  async onVisibleChange(val: boolean) {
    if (val) {
      await this.buscarLogs()
    } else {
      this.logs = []
    }
  }

  async buscarLogs() {
    this.loading = true
    try {
      const response = await Apis.Agendamento.SuporteApi.getLogsAlteracaoTipo(this.usuarioId)
      if (response.success) {
        this.logs = response.data || []
      }
    } finally {
      this.loading = false
    }
  }

  labelTipo(tipo: string): string {
    return TIPO_USUARIO_LABELS[tipo] || tipo || '—'
  }

  formatarData(data: string): string {
    if (!data) return '—'
    return moment(data).format('DD/MM/YYYY HH:mm')
  }
}
